var customerOrVisitorWishlists = [];
var customerWishlistedTmProductIds = [];
var removeCollaboratorFromWishlistAjax = null;
var addingTmProductIdToWishlist = null;
var editingWishlistGroupToken = null;
var deletingWishlistGroupToken = null;
var settingsWishlistObject = null;
var wishlistDetailPageWishlistObject = typeof wishlistDetailPageWishlistObject !== 'undefined' ? wishlistDetailPageWishlistObject : null;
var wishlistModalEl = $('#wishlist-modal');
var wishlistEmptyIcon = $("body.cool-profile").length ? 'fa-jelly fa-regular fa-heart' : 'fa-light fa-heart fa-fw';
var wishlistFillIcon = $("body.cool-profile").length ? 'fa-jelly-fill fa-regular fa-heart' : 'fa-solid fa-heart fa-fw';

tmWishlist = function () {
    return {
        wishlistFolderHtmlTemplate: function (customerOrVisitorWishlist) {
            let wishlistSavedCount = customerOrVisitorWishlist.hasOwnProperty('wishlist_tm_product_ids') && customerOrVisitorWishlist.wishlist_tm_product_ids.length >= 0 ? customerOrVisitorWishlist.wishlist_tm_product_ids.length : 0;
            let wishlistThumbImgUrl = customerOrVisitorWishlist.hasOwnProperty('wishlist_thumb_url') ? customerOrVisitorWishlist.wishlist_thumb_url : null;


            return '<div>' +
                    '   <div class="wishlist-category">' +
                    '       <button class="wishlist-folder-selector" data-id="' + customerOrVisitorWishlist.id + '"></button>' +
                    '       <div class="wishlist-card">' +
                    '           <div class="wishlist-card-header">' +
                    '               <div class="wishlist-aspect-ratio">' +
                    '                   <div class="wishlist-aspect-ratio-inner">' +
                                            (wishlistThumbImgUrl ? '<img alt="" src="'+wishlistThumbImgUrl+'" />' : '<div class="wishlist-no-photo"><i class="'+wishlistEmptyIcon+'" aria-hidden="true"></i></div>')  +
                    '                   </div>' +
                    '               </div>' +
                    '           </div>' +
                    '           <div class="wishlist-card-footer">' +
                    '               <div class="wishlist-card-footer-heading">' + customerOrVisitorWishlist.name + '</div>' +
                    '               <div class="wishlist-card-footer-saved">' + wishlistSavedCount + ' saved</div>' +
                    '           </div>' +
                    '       </div>' +
                    '   </div>' +
                    '</div>'
        },

        processCustomerOrVisitorWishlists: function () {
            customerWishlistedTmProductIds = [];
            let wishlistItemsGridHtml = '';
            customerOrVisitorWishlists.forEach(function (customerOrVisitorWishlist) {
                if (customerOrVisitorWishlist.hasOwnProperty('wishlist_tm_product_ids')) {
                    customerWishlistedTmProductIds = customerWishlistedTmProductIds.concat(customerOrVisitorWishlist.wishlist_tm_product_ids)
                }
                wishlistItemsGridHtml += tmWishlist.wishlistFolderHtmlTemplate(customerOrVisitorWishlist);
            })
            wishlistModalEl.find('.wishlist-items-grid').html(wishlistItemsGridHtml);
            tmWishlist.refreshWishlistStatusToAllProducts();
        },

        toggleWishlistStatusForTmProduct: function (tmProductId, actionOnlyForAdd = false) {
            if (customerWishlistedTmProductIds.includes(tmProductId))  {
                if (!actionOnlyForAdd) {
                    tmWishlist.addRemoveProductToCustomerWishlist(tmProductId, 'remove');
                }
            }
            else {
                try{
                    fbq('track', 'AddToWishlist');
                } catch (e) {}
                addingTmProductIdToWishlist = tmProductId;
                if (customerOrVisitorWishlists.length > 0) {
                    tmWishlist.showWishlistModal('chooseList');
                }
                else {
                    tmWishlist.showWishlistModal('createList');
                }
            }
        },

        addRemoveProductToCustomerWishlist: function(tmProductId, addOrRemove = 'add', tmWishlistId = null, tmWishlistNameIfNew = '') {
            jQuery.ajax({
                type: "post",
                url: ajaxurl,
                dataType: "json",
                data: {
                    "action": "add_remove_visitor_customer_wishlist_item",
                    "tm_product_id": tmProductId,
                    "add_or_remove" : addOrRemove,
                    "tm_wishlist_id" : tmWishlistId,
                    "tm_wishlist_name" : tmWishlistNameIfNew,
                    "tmv_identifier" : tmVisitorStore.getDetail('identifier'),
                },
                success ( returnJSON ) {
                    if (returnJSON.hasOwnProperty('customerOrVisitorWishlists')) {
                        customerOrVisitorWishlists = returnJSON.customerOrVisitorWishlists;
                        tmWishlist.processCustomerOrVisitorWishlists();
                        if (addOrRemove === 'add') {
                            jQuery(document).trigger('tmToasterTrigger', {icon: wishlistFillIcon, text: `Saved to your wishlist`});
                        }
                        else if (addOrRemove === 'remove'){
                            jQuery(document).trigger('tmToasterTrigger', {icon: wishlistEmptyIcon, text: `Removed from your wishlist`});
                        }
                    }
                },
                error(jqXHR, textStatus, errorThrown) {
                    tmWishlist.redirectToWishlistPage(tmProductId);
                }
            })
        },

        deleteWishlistGroup: function (tmWishlistToken) {
            jQuery.ajax({
                type: "post",
                url: ajaxurl,
                dataType: "json",
                data: {
                    "action": "delete_visitor_customer_wishlist_group",
                    "tm_wishlist_token" : tmWishlistToken,
                },
                success () {
                    tmWishlist.redirectToWishlistPage();
                },
                error(jqXHR, textStatus, errorThrown) {
                    tmWishlist.redirectToWishlistPage();
                }
            })
        },

        renameWishlistGroup: function (tmWishlistToken, tmWishlistName) {
            jQuery.ajax({
                type: "post",
                url: ajaxurl,
                dataType: "json",
                data: {
                    "action": "rename_visitor_customer_wishlist_group",
                    "name": tmWishlistName,
                    "tm_wishlist_token" : tmWishlistToken,
                },
                success () {
                    tmWishlist.redirectToWishlistDetailPage(tmWishlistToken);
                },
                error(jqXHR, textStatus, errorThrown) {
                    tmWishlist.redirectToWishlistDetailPage(tmWishlistToken);
                }
            })
        },

        removeCollaboratorFromWishlist: function (collaborateAction, tmWishlistToken, tmwuId) {
            if (removeCollaboratorFromWishlistAjax) {
                return;
            }
            removeCollaboratorFromWishlistAjax = jQuery.ajax({
                type: "post",
                url: ajaxurl,
                dataType: "json",
                data: {
                    "action": "leave_remove_wishlist_collaborator",
                    "tm_wishlist_token" : tmWishlistToken,
                    "tmwu_id": tmwuId,
                    "collaborate_action": collaborateAction,
                },
                success (returnJSON) {
                    if (returnJSON.wishlist_collaborators && collaborateAction === 'remove') {
                        wishlistDetailPageWishlistObject.wishlist_collaborators = returnJSON.wishlist_collaborators;
                        tmWishlist.hideWishlistModal();
                    }
                    else {
                        tmWishlist.redirectToWishlistDetailPage(tmWishlistToken);
                    }
                },
                error(jqXHR, textStatus, errorThrown) {
                    tmWishlist.redirectToWishlistDetailPage(tmWishlistToken);
                },
                complete() {
                    removeCollaboratorFromWishlistAjax = null;
                }
            })
        },

        processTmProductWishlistStatus: function (favouriteIconEl) {
            let favouriteIconElTmActivityId = favouriteIconEl.attr('data-tm-activity-id') ?? null;
            if (customerWishlistedTmProductIds.includes(favouriteIconElTmActivityId)) {
                if ( $("body.cool-profile").length ){
                    favouriteIconEl.find("i").removeClass("fa-jelly").addClass("fa-jelly-fill");
                }else{
                    favouriteIconEl.find("i").removeClass("far").addClass("fas");
                }
                favouriteIconEl.find('.wish-list-title').text( 'Added to Wishlist' );
            }
            else {
                if ( $("body.cool-profile").length ){
                    favouriteIconEl.find("i").removeClass("fa-jelly-fill").addClass("fa-jelly");
                }else{
                    favouriteIconEl.find("i").removeClass("fas").addClass("far");
                }

                favouriteIconEl.find('.wish-list-title').text( 'Add to Wishlist' );
                if ( $("#tm-account-dashboard .wish-list-carousel").length !== 0 ){
                    let wishlistPageRemovedProductEl = $("#tm-account-dashboard .wish-list-carousel [data-tm-activity-id=" + favouriteIconElTmActivityId + "]");
                    wishlistPageRemovedProductEl.parents(".slider-item").fadeOut(500);
                    wishlistPageRemovedProductEl.parents(".col-12").fadeOut(500);
                }
            }
        },

        refreshWishlistStatusToAllProducts: function () {
            let wishlistableIcons = $('.favorite-icon');
            wishlistableIcons.each(function (i, obj) {
                tmWishlist.processTmProductWishlistStatus($(obj));
            });
        },

        redirectToWishlistPage: function (tmProductId = null) {
            let url = window.location.origin +"/wishlist/";
            if (tmProductId) {
                url += '?add_to_wishlist=' + tmProductId;
            }
            window.location = url;
        },

        redirectToWishlistDetailPage: function (tmWishlistToken) {
            window.location = window.location.origin + "/wishlist/" + tmWishlistToken;
        },

        validateModalWishlistCreate: function (validateFor = 'create') {
            let wishlistName = $('#wishlist-modal #wishlist-modal-new-edit-wishlist-name').val().trim();
            $('#wishlist-modal #wishlist-modal-create-edit-new-list .info-area span').text(wishlistName.length)
            if (validateFor === 'create') {
                if (wishlistName.length > 0 && wishlistName.length <= 50) {
                    $('#wishlist-modal #wishlist-modal-create-new-list-footer-submit').attr('disabled', false);
                    return wishlistName;
                }
                else {
                    $('#wishlist-modal #wishlist-modal-create-new-list-footer-submit').attr('disabled', true);
                }
            }
            else if (validateFor === 'edit') {
                if (wishlistName.length > 0 && wishlistName.length <= 50 && editingWishlistGroupToken !== null && settingsWishlistObject.hasOwnProperty('name') && settingsWishlistObject.name.replace("\\", "") !== wishlistName) {
                    $('#wishlist-modal #wishlist-modal-edit-list-footer-submit').attr('disabled', false);
                    return wishlistName;
                }
                else {
                    $('#wishlist-modal #wishlist-modal-edit-list-footer-submit').attr('disabled', true);
                }
            }

            return null;
        },

        showWishlistModal: function (subType = 'chooseList') {
            let wishlistModalHeading = '';
            wishlistModalEl.find(".display-contents-inner").removeClass().addClass('display-contents-inner ' + subType);
            wishlistModalEl.find('#wishlist-modal-existing-lists').hide();
            wishlistModalEl.find('#wishlist-modal-create-edit-new-list').hide();
            wishlistModalEl.find('#wishlist-modal-existing-lists-footer').hide();
            wishlistModalEl.find('#wishlist-modal-create-new-list-footer').hide();
            wishlistModalEl.find('#wishlist-modal-edit-list-footer').hide();
            wishlistModalEl.find('#setting-options').hide();
            wishlistModalEl.find('#wishlist-share-entry').hide();
            wishlistModalEl.find('#wishlist-share-invite-public-link').hide();
            wishlistModalEl.find('#wishlist-share-invite-collaborators-link').hide();
            wishlistModalEl.find('#wishlist-share-collaborators-list').hide();
            wishlistModalEl.find('.modal-footer').show();

            wishlistModalEl.removeClass('small-modal');
            if (subType === 'chooseList' && addingTmProductIdToWishlist) {
                wishlistModalHeading = 'Add to wishlist'
                wishlistModalEl.find('#wishlist-modal-existing-lists').show();
                wishlistModalEl.find('#wishlist-modal-existing-lists-footer').show();
            }
            else if (subType === 'createList' && addingTmProductIdToWishlist) {
                wishlistModalHeading = 'Create wishlist';
                wishlistModalEl.find('#wishlist-modal-create-edit-new-list').show();
                wishlistModalEl.find('#wishlist-modal-create-new-list-footer').show();
                tmWishlist.validateModalWishlistCreate('create');
            }
            else if (subType === 'wishlistItemSettings' && settingsWishlistObject) {
                wishlistModalEl.find('.modal-footer').hide();
                wishlistModalHeading = 'Settings';
                wishlistModalEl.addClass('small-modal');
                wishlistModalEl.find('#setting-options').show();
            }
            else if (subType === 'wishlistItemRename' && settingsWishlistObject && editingWishlistGroupToken) {
                wishlistModalHeading = 'Rename wishlist';
                wishlistModalEl.addClass('small-modal');
                wishlistModalEl.find('#wishlist-modal-create-edit-new-list #wishlist-modal-new-edit-wishlist-name').val(settingsWishlistObject.name.replace("\\", ""));
                wishlistModalEl.find('#wishlist-modal-create-edit-new-list').show();
                wishlistModalEl.find('#wishlist-modal-edit-list-footer').show();
                tmWishlist.validateModalWishlistCreate('edit');
            }
            else if (subType === 'wishlistItemShare') {
                wishlistModalEl.find('.modal-footer').hide();
                wishlistModalHeading = 'How do you want to share?';
                let collaboratingMembersCount = wishlistDetailPageWishlistObject.wishlist_collaborators.length - 1;
                wishlistModalEl.find('#wishlist-share-entry #wishlist-share-entry-collaborator-line').show();
                if (collaboratingMembersCount > 0) {
                    let entryCollaboratorLine = 'Other ' + collaboratingMembersCount + ' ' + (collaboratingMembersCount > 1 ? 'members are' : 'member is') + ' collaborating with you. <a class="' + link_color + '" href="javascript:void(0)">Update</a>'
                    wishlistModalEl.find('#wishlist-share-entry #wishlist-share-entry-collaborator-line').html(entryCollaboratorLine).show();
                }
                wishlistModalEl.find('#wishlist-share-entry').show();
            }
            else if (subType === 'wishlistItemShareInvitePublicLink') {
                wishlistModalEl.find('.modal-footer').hide();
                wishlistModalHeading = 'Send a link to your wishlist';
                wishlistModalEl.find('#wishlist-share-invite-public-link .activity-detail img').attr('src', wishlistDetailPageWishlistObject.wishlist_thumb_url ?? '');
                wishlistModalEl.find('#wishlist-share-invite-public-link .activity-detail-sub').text('Wishlist: ' + wishlistDetailPageWishlistObject.name + ' · ' + wishlistDetailPageWishlistObject.wishlist_tm_product_ids.length + ' saved');
                let publicLinksHtml = '';
                Object.keys(wishlistDetailPageWishlistObject.share_links.view_only).forEach(function (shareLinkKey) {
                    let shareLinkData = wishlistDetailPageWishlistObject.share_links.view_only[shareLinkKey];
                    publicLinksHtml += '<div class="sharing-ghost-button">\n' +
                        '                   <button data-share-type="'+shareLinkKey+'" data-link="'+shareLinkData.url+'" class="sharing-ghost-button-wrapper wishlist-share-trigger-button-el">\n' +
                        '                       <div class="sharing-ghost-button-inner">\n' +
                        '                           <div class="sharing-ghost-button-icon">\n' +
                        '                               <i class="'+shareLinkData.icon+' fa-fw"></i>\n' +
                        '                           </div>\n' +
                        '                           <div class="sharing-ghost-button-text">'+shareLinkData.title+'</div>\n' +
                        '                       </div>\n' +
                        '                   </button>\n' +
                        '               </div>';
                });
                wishlistModalEl.find('#wishlist-share-invite-public-link #wishlist-share-invite-public-link-lists-wrapper').html(publicLinksHtml);
                wishlistModalEl.find('#wishlist-share-invite-public-link').show();
            }
            else if (subType === 'wishlistItemShareInviteCollaboratorsLink') {
                wishlistModalEl.find('.modal-footer').hide();
                wishlistModalHeading = 'Invite others to join';
                wishlistModalEl.find('#wishlist-share-invite-collaborators-link .activity-detail img').attr('src', wishlistDetailPageWishlistObject.wishlist_thumb_url ?? '');
                wishlistModalEl.find('#wishlist-share-invite-collaborators-link .activity-detail-sub').text('Wishlist: ' + wishlistDetailPageWishlistObject.name + ' · ' + wishlistDetailPageWishlistObject.wishlist_tm_product_ids.length + ' saved');
                let collaborateLinksHtml = '';
                Object.keys(wishlistDetailPageWishlistObject.share_links.collaborate).forEach(function (shareLinkKey) {
                    let shareLinkData = wishlistDetailPageWishlistObject.share_links.collaborate[shareLinkKey];
                    collaborateLinksHtml += '<div class="sharing-ghost-button">\n' +
                        '                   <button data-share-type="'+shareLinkKey+'" data-link="'+shareLinkData.url+'" class="sharing-ghost-button-wrapper wishlist-share-trigger-button-el">\n' +
                        '                       <div class="sharing-ghost-button-inner">\n' +
                        '                           <div class="sharing-ghost-button-icon">\n' +
                        '                               <i class="'+shareLinkData.icon+' fa-fw"></i>\n' +
                        '                           </div>\n' +
                        '                           <div class="sharing-ghost-button-text">'+shareLinkData.title+'</div>\n' +
                        '                       </div>\n' +
                        '                   </button>\n' +
                        '               </div>';
                });
                wishlistModalEl.find('#wishlist-share-invite-collaborators-link #wishlist-share-invite-collaborators-link-lists-wrapper').html(collaborateLinksHtml);
                wishlistModalEl.find('#wishlist-share-invite-collaborators-link').show();
            }
            else if (subType === 'wishlistItemShareCollaboratorsList') {
                wishlistModalEl.find('.modal-footer').hide();
                wishlistModalHeading = 'Collaborators';
                let collaboratorListHtml = '';
                wishlistDetailPageWishlistObject.wishlist_collaborators.forEach(function (collaborator) {
                    let collaboratorAction = null;
                    if (wishlistDetailPageWishlistObject.tmwu_role === 'owner' && collaborator.wishlist_role === 'collaborator') {
                        collaboratorAction = 'remove';
                    }
                    else if (wishlistDetailPageWishlistObject.tmwu_id === collaborator.tmwu_id && wishlistDetailPageWishlistObject.tmwu_role === 'collaborator' && collaborator.wishlist_role === 'collaborator') {
                        collaboratorAction = 'leave';
                    }
                    let collaboratorListActionHtml = '';
                    if (collaboratorAction) {
                        collaboratorListActionHtml = '<div class="wishlist-share-collaborators-list-single-row-action"><button data-tmwu-id="'+collaborator.tmwu_id+'" data-action="'+collaboratorAction+'">'+collaboratorAction+'</button></div>';
                    }
                    collaboratorListHtml += '<div class="wishlist-share-collaborators-list-single-row">\n' +
                        '                            <div class="wishlist-share-collaborators-list-single-row-inner">\n' +
                        '                                <div class="wishlist-share-collaborators-list-single-row-avatar">\n' +
                        '                                    <div class="wishlist-share-collaborators-list-single-row-avatar-inner">\n' +
                        '                                        <div class="wishlist-share-collaborators-list-single-row-avatar-initial">'+collaborator.displayName.charAt(0)+'</div>\n' +
                        '                                    </div>\n' +
                        '                                </div>\n' +
                        '                                <div class="wishlist-share-collaborators-list-single-row-name">\n' +
                        '                                    <div class="wishlist-share-collaborators-list-single-row-name-main">' + (wishlistDetailPageWishlistObject.tmwu_id === collaborator.tmwu_id ? 'You' : collaborator.displayName) + '</div>\n' +
                        '                                    <div class="wishlist-share-collaborators-list-single-row-name-tagline">'+(collaborator.wishlist_role === 'owner' ? 'Owner' : '')+'</div>\n' +
                        '                                </div>\n' +
                        '                                ' + collaboratorListActionHtml +
                        '                            </div>\n' +
                        '                        </div> ';
                });
                wishlistModalEl.find('#wishlist-share-collaborators-list').html(collaboratorListHtml).show();
            }
            wishlistModalEl.find('.wishlist-modal-heading').text(wishlistModalHeading);
            wishlistModalEl.css('display', 'flex');
            $("body").css("overflow","hidden");
        },

        hideWishlistModal: function () {
            if (wishlistModalEl.is(':visible')) {
                wishlistModalEl.css('display', 'none');
                $("body").css("overflow","auto");
                addingTmProductIdToWishlist = null;
                settingsWishlistObject = null;
            }
        },
    }
}(window);

jQuery(document).on('tmActivitiesSubsetListRefreshed', function () {
    tmWishlist.refreshWishlistStatusToAllProducts();
});

$(document).on("touchstart click", ".favorite-icon", function(e) {
    e.preventDefault();
    let tmProductId = $(this).attr('data-tm-activity-id');
    if (tmProductId && tmProductId > 0) {
        tmWishlist.toggleWishlistStatusForTmProduct(tmProductId);
    }
    return false;
});

$('#wishlist-modal #wishlist-modal-new-wishlist-go-button').click(function(){
    tmWishlist.showWishlistModal('createList');
});

$('#wishlist-modal #wishlist-modal-create-new-list-footer-back').click(function(){
    if (customerOrVisitorWishlists.length > 0) {
        tmWishlist.showWishlistModal('chooseList');
    }
    else {
        tmWishlist.hideWishlistModal();
    }
});

$('#wishlist-modal #wishlist-modal-create-new-list-footer-submit').click(function(){
    let validatedName = tmWishlist.validateModalWishlistCreate('create');
    if (validatedName.length > 0 && validatedName.length <= 50 && addingTmProductIdToWishlist > 0) {
        $('#wishlist-modal #wishlist-modal-create-new-list-footer-submit').attr('disabled', true);
        tmWishlist.addRemoveProductToCustomerWishlist(addingTmProductIdToWishlist, 'add', null, validatedName);
        tmWishlist.hideWishlistModal();
    }
});

$(document).on('click', '#wishlist-modal .wishlist-folder-selector' , function () {
    let selectedWishlistId = $(this).attr('data-id');
    if (selectedWishlistId > 0 && addingTmProductIdToWishlist > 0) {
        tmWishlist.addRemoveProductToCustomerWishlist(addingTmProductIdToWishlist, 'add', selectedWishlistId);
        tmWishlist.hideWishlistModal();
    }
});

$('#wishlist-settings-btn').click(function () {
    if (wishlistDetailPageWishlistObject) {
        if(wishlistDetailPageWishlistObject.tmwu_role === 'owner') {
            settingsWishlistObject = wishlistDetailPageWishlistObject
            if (settingsWishlistObject.id && settingsWishlistObject.token) {
                tmWishlist.showWishlistModal('wishlistItemSettings');
            }
        }
        else if(wishlistDetailPageWishlistObject.wishlist_collaborators.length > 1) {
            tmWishlist.showWishlistModal('wishlistItemShareCollaboratorsList');
        }
    }
});

$('#wishlist-share-btn').click(function () {
    if (wishlistDetailPageWishlistObject) {
        tmWishlist.showWishlistModal('wishlistItemShare');
    }
});

$(document).on('input', '#wishlist-modal #wishlist-modal-new-edit-wishlist-name' , function () {
    tmWishlist.validateModalWishlistCreate('create');
    tmWishlist.validateModalWishlistCreate('edit');
});


$(document).on('click', '#wishlist-modal #setting-rename' , function () {
    if (settingsWishlistObject) {
        editingWishlistGroupToken = settingsWishlistObject.token;
        tmWishlist.showWishlistModal('wishlistItemRename');
    }
});

$(document).on('click', '#wishlist-modal #wishlist-share-invite-public-link-btn' , function () {
    if(wishlistDetailPageWishlistObject.share_links.view_only.copyUrl !== undefined) {
        tmWishlist.showWishlistModal('wishlistItemShareInvitePublicLink');
    }
});

$(document).on('click', '#wishlist-modal #wishlist-share-invite-collaborators-link-btn' , function () {
    if(wishlistDetailPageWishlistObject.share_links.collaborate.copyUrl !== undefined) {
        tmWishlist.showWishlistModal('wishlistItemShareInviteCollaboratorsLink');
    }
});

$(document).on('click', '#wishlist-modal #wishlist-share-entry-collaborator-line' , function () {
    if(wishlistDetailPageWishlistObject.wishlist_collaborators.length > 1) {
        tmWishlist.showWishlistModal('wishlistItemShareCollaboratorsList');
    }
});

$('#wishlist-modal #wishlist-modal-edit-list-footer-back').click(function(){
    editingWishlistGroupToken = null;
    tmWishlist.showWishlistModal('wishlistItemSettings');
});

$('#wishlist-modal #wishlist-modal-edit-list-footer-submit').click(function(){
    let validatedName = tmWishlist.validateModalWishlistCreate('edit');
    if (validatedName.length > 0 && validatedName.length <= 50 && editingWishlistGroupToken !== null && editingWishlistGroupToken.length > 0) {
        $('#wishlist-modal #wishlist-modal-edit-list-footer-submit').attr('disabled', true);
        tmWishlist.renameWishlistGroup(editingWishlistGroupToken, validatedName);
    }
});


$(document).on('click', '#wishlist-modal #setting-delete' , function (e) {
    e.preventDefault();
    if (settingsWishlistObject) {
        deletingWishlistGroupToken = settingsWishlistObject.token;
        tmWishlist.hideWishlistModal();
        tmYesNoModal.showModal('Delete this wishlist?', 'It will be permanently deleted.', 'Cancel', 'Delete', 'deleteWishlistPopupClosedReopenSettings', 'deleteWishlistPopupAction')
    }
    return false;
});

$('#wishlist-folders .wishlist-category .delete-wishlist').click(function(e){
    e.preventDefault();
    deletingWishlistGroupToken = $(this).attr('data-token');
    tmYesNoModal.showModal('Delete this wishlist?', 'It will be permanently deleted.', 'Cancel', 'Delete', 'deleteWishlistPopupClosed', 'deleteWishlistPopupAction')
});

$(document).on('click', '.wishlist-share-collaborators-list-single-row-action button' , function (e) {
    e.preventDefault();
    if (wishlistDetailPageWishlistObject.token && $(this).attr('data-tmwu-id').length > 0 && ['remove', 'leave'].includes($(this).attr('data-action'))) {
        tmWishlist.removeCollaboratorFromWishlist($(this).attr('data-action'), wishlistDetailPageWishlistObject.token, $(this).attr('data-tmwu-id'));
    }
});

$(document).on('click', '.wishlist-share-trigger-button-el', function(e){
    e.preventDefault();
    let buttonType = $(this).attr('data-share-type');
    let buttonHref = $(this).attr('data-link');
    if (buttonType === 'copyUrl') {
        navigator.clipboard.writeText(buttonHref).then(() => {
            /* Resolved - text copied to clipboard successfully */
        },() => {
            /* Rejected - text failed to copy to the clipboard */
        });
    }
    else if (['facebook', 'twitter'].includes(buttonType)) {
        window.open(buttonHref, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');
    }
    else if (['whatsapp'].includes(buttonType)) {
        window.open(buttonHref);
    }
    else if (['mail', 'sms'].includes(buttonType)) {
        window.location.href = buttonHref;
    }
});

$(document).on('deleteWishlistPopupClosed' , function () {
    deletingWishlistGroupToken = null;
});

$(document).on('deleteWishlistPopupClosedReopenSettings' , function () {
    deletingWishlistGroupToken = null;
    if (wishlistDetailPageWishlistObject) {
        settingsWishlistObject = wishlistDetailPageWishlistObject
        if (settingsWishlistObject.id && settingsWishlistObject.token) {
            tmWishlist.showWishlistModal('wishlistItemSettings');
        }
    }
});

$(document).on('deleteWishlistPopupAction' , function () {
    if (deletingWishlistGroupToken) {
        tmWishlist.deleteWishlistGroup(deletingWishlistGroupToken);
    }
    else {
        tmYesNoModal.hideModal();
    }
});

jQuery(document).on('tmBlogUserLoginStatusChanged', function (e, data) {
    if (data.customerOrVisitorWishlists) {
        customerOrVisitorWishlists = data.customerOrVisitorWishlists;
        tmWishlist.processCustomerOrVisitorWishlists();
    }
});


$('#wishlist-modal .modal-close').click(function(){
    tmWishlist.hideWishlistModal();
});
$(document).click(function(e){
    if (
        !(
            $(e.target).parents('#wishlist-modal .display-contents-inner').length
            || $(e.target).is('#wishlist-modal .display-contents-inner')
            || $(e.target).parents('#wishlist-settings-btn').length
            || $(e.target).is('#wishlist-settings-btn')
            || $(e.target).parents('#wishlist-share-btn').length
            || $(e.target).is('#wishlist-share-btn')
            || $(e.target).parents('#wishlist-share-entry-collaborator-line').length
            || $(e.target).is('#wishlist-share-entry-collaborator-line')
            || $(e.target).parents('#yes-no-modal-left-btn').length
            || $(e.target).is('#yes-no-modal-left-btn')
        )
    ) {
        tmWishlist.hideWishlistModal();
    }
});
